var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Comp',{attrs:{"language":_vm.language,"channel-configs":_vm.channelConfigs},on:{"handle-share":_vm.handleShare}})}
var staticRenderFns = []

export { render, staticRenderFns }